<template>
    <button
        class="IconButton"
        type="button"
        :class="computedClass"
        @click="click"
    >
        <font-awesome-icon v-if="icon" :icon="icon" />
    </button>
</template>

<script>
export default {
    name: 'IconButton',
    props: {
        borderColor: {
            type: String,
            default: 'white',
        },
        icon: {
            type: String,
            required: true,
        },
    },
    computed: {
        computedClass() {
            return {
                [`border-${this.borderColor}`]: true,
            };
        },
    },
    methods: {
        click() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/bulma/projectBulma.scss';

.IconButton {
    padding: 5px;
    background-color: transparent;
    border: none;
    color: #aaa;
    font-size: 1.2em;
    font-weight: normal;
    cursor: pointer;

    &:hover {
        color: #ddd;
    }

    svg {
        transition: 0.05s ease-out color;
    }
}
</style>
